export default {
  meta: {
    title: '小天才商圈报告 PDF',
  },
};
